import {Button} from "primereact/button";
import type {ColumnFilterApplyTemplateOptions, ColumnFilterClearTemplateOptions} from "primereact/column";
import {useTranslation} from "react-i18next";

/**
 * Einheitliche Apply-/Clear-Buttons für die Filter-Overlays unserer DataTables (Startseiten-Listen,
 * Dokumenten-Tabelle) — als `filterApply`/`filterClear`-Template an die jeweilige Column geben.
 */

function FilterClearButton({options}: {options: ColumnFilterClearTemplateOptions}) {
    const {t} = useTranslation();
    return (
        <Button
            type="button"
            icon="pi pi-times"
            size="small"
            onClick={options.filterClearCallback}
            severity="danger"
            text
            label={t("general.clear")}
        />
    );
}

function FilterApplyButton({options}: {options: ColumnFilterApplyTemplateOptions}) {
    const {t} = useTranslation();
    return (
        <Button
            type="button"
            icon="pi pi-check"
            size="small"
            onClick={options.filterApplyCallback}
            severity="success"
            className="ml-4"
            label={t("general.apply")}
        />
    );
}

export const filterClearTemplate = (options: ColumnFilterClearTemplateOptions) => (
    <FilterClearButton options={options} />
);

export const filterApplyTemplate = (options: ColumnFilterApplyTemplateOptions) => (
    <FilterApplyButton options={options} />
);
